export const CHANGE_PASSWORD_SERVICE = "changePasswordService";

export class ChangePasswordService {
    static $inject = ["$q", "$http", "BoardWebAdminUserManager"];
    constructor(private $q: ng.IQService, private $http: ng.IHttpService, private userManager: Oidc.UserManager) {

    }

    changePassword(oldPassword: string, newPassword: string, confirmNewPassword: string) {
        if (oldPassword == newPassword) {
            return this.$q.reject("New password must be different from old password");
        }

        if (newPassword != confirmNewPassword) {
            return this.$q.reject("Passwords doesn't match");
        }

        return this.$http.get<void>(`identity/ChangePassword`, {
            params: {
                oldPassword: oldPassword,
                newPassword: newPassword
            }
        }).then(() => {
            this.userManager.signinRedirect();
        }, reason => {
            return this.$q.reject(reason.data.message);
        });
    }
}


// WEBPACK FOOTER //
// ./app/change-password/change-password.service.ts